import _regeneratorRuntime from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import EventEmitter from "eventemitter3";
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import { IJsonRpcConnection } from "@walletconnect/jsonrpc-types";
import { formatJsonRpcError } from "@walletconnect/jsonrpc-utils";
export var SignerConnection = /*#__PURE__*/function (_IJsonRpcConnection) {
  _inherits(SignerConnection, _IJsonRpcConnection);

  var _super = _createSuper(SignerConnection);

  function SignerConnection(opts) {
    var _this;

    _classCallCheck(this, SignerConnection);

    _this = _super.call(this);
    _this.events = new EventEmitter();
    _this.accounts = [];
    _this.chainId = 1;
    _this.pending = false;
    _this.bridge = "https://bridge.walletconnect.org";
    _this.qrcode = true;
    _this.qrcodeModalOptions = undefined;
    _this.opts = opts;
    _this.chainId = (opts === null || opts === void 0 ? void 0 : opts.chainId) || _this.chainId;
    _this.wc = _this.register(opts);
    return _this;
  }

  _createClass(SignerConnection, [{
    key: "connected",
    get: function get() {
      return typeof this.wc !== "undefined" && this.wc.connected;
    }
  }, {
    key: "connecting",
    get: function get() {
      return this.pending;
    }
  }, {
    key: "connector",
    get: function get() {
      this.wc = this.register(this.opts);
      return this.wc;
    }
  }, {
    key: "on",
    value: function on(event, listener) {
      this.events.on(event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      this.events.once(event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      this.events.off(event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      this.events.removeListener(event, listener);
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(chainId) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.connected) {
                  _context.next = 3;
                  break;
                }

                this.onOpen();
                return _context.abrupt("return");

              case 3:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  _this2.on("error", function (err) {
                    reject(err);
                  });

                  _this2.on("open", function () {
                    resolve();
                  });

                  _this2.create(chainId);
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open(_x) {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof this.wc === "undefined")) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (this.wc.connected) {
                  this.wc.killSession();
                }

                this.onClose();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.wc = this.register(this.opts);

                if (this.connected) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return this.open();

              case 4:
                this.sendPayload(payload).then(function (res) {
                  return _this3.events.emit("payload", res);
                }).catch(function (e) {
                  return _this3.events.emit("payload", formatJsonRpcError(payload.id, e.message));
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function send(_x2) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "register",
    value: function register(opts) {
      if (this.wc) return this.wc;
      this.opts = opts || this.opts;
      this.bridge = (opts === null || opts === void 0 ? void 0 : opts.connector) ? opts.connector.bridge : (opts === null || opts === void 0 ? void 0 : opts.bridge) || "https://bridge.walletconnect.org";
      this.qrcode = typeof (opts === null || opts === void 0 ? void 0 : opts.qrcode) === "undefined" || opts.qrcode !== false;
      this.chainId = typeof (opts === null || opts === void 0 ? void 0 : opts.chainId) !== "undefined" ? opts.chainId : this.chainId;
      this.qrcodeModalOptions = opts === null || opts === void 0 ? void 0 : opts.qrcodeModalOptions;
      var connectorOpts = {
        bridge: this.bridge,
        qrcodeModal: this.qrcode ? QRCodeModal : undefined,
        qrcodeModalOptions: this.qrcodeModalOptions,
        storageId: opts === null || opts === void 0 ? void 0 : opts.storageId,
        signingMethods: opts === null || opts === void 0 ? void 0 : opts.signingMethods,
        clientMeta: opts === null || opts === void 0 ? void 0 : opts.clientMeta
      };
      this.wc = typeof (opts === null || opts === void 0 ? void 0 : opts.connector) !== "undefined" ? opts.connector : new WalletConnect(connectorOpts);

      if (typeof this.wc === "undefined") {
        throw new Error("Failed to register WalletConnect connector");
      }

      if (this.wc.accounts.length) {
        this.accounts = this.wc.accounts;
      }

      if (this.wc.chainId) {
        this.chainId = this.wc.chainId;
      }

      this.registerConnectorEvents();
      return this.wc;
    }
  }, {
    key: "onOpen",
    value: function onOpen(wc) {
      this.pending = false;

      if (wc) {
        this.wc = wc;
      }

      this.events.emit("open");
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.pending = false;

      if (this.wc) {
        this.wc = undefined;
      }

      this.events.emit("close");
    }
  }, {
    key: "onError",
    value: function onError(payload) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Failed or Rejected Request";
      var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -32000;
      var errorPayload = {
        id: payload.id,
        jsonrpc: payload.jsonrpc,
        error: {
          code: code,
          message: message
        }
      };
      this.events.emit("payload", errorPayload);
      return errorPayload;
    }
  }, {
    key: "create",
    value: function create(chainId) {
      var _this4 = this;

      this.wc = this.register(this.opts);
      this.chainId = chainId || this.chainId;
      if (this.connected || this.pending) return;
      this.pending = true;
      this.registerConnectorEvents();
      this.wc.createSession({
        chainId: this.chainId
      }).then(function () {
        return _this4.events.emit("created");
      }).catch(function (e) {
        return _this4.events.emit("error", e);
      });
    }
  }, {
    key: "registerConnectorEvents",
    value: function registerConnectorEvents() {
      var _this5 = this;

      this.wc = this.register(this.opts);
      this.wc.on("connect", function (err) {
        var _a, _b;

        if (err) {
          _this5.events.emit("error", err);

          return;
        }

        _this5.accounts = ((_a = _this5.wc) === null || _a === void 0 ? void 0 : _a.accounts) || [];
        _this5.chainId = ((_b = _this5.wc) === null || _b === void 0 ? void 0 : _b.chainId) || _this5.chainId;

        _this5.onOpen();
      });
      this.wc.on("disconnect", function (err) {
        if (err) {
          _this5.events.emit("error", err);

          return;
        }

        _this5.onClose();
      });
      this.wc.on("modal_closed", function () {
        _this5.events.emit("error", new Error("User closed modal"));
      });
      this.wc.on("session_update", function (error, payload) {
        var _payload$params$ = payload.params[0],
            accounts = _payload$params$.accounts,
            chainId = _payload$params$.chainId;

        if (!_this5.accounts || accounts && _this5.accounts !== accounts) {
          _this5.accounts = accounts;

          _this5.events.emit("accountsChanged", accounts);
        }

        if (!_this5.chainId || chainId && _this5.chainId !== chainId) {
          _this5.chainId = chainId;

          _this5.events.emit("chainChanged", chainId);
        }
      });
    }
  }, {
    key: "sendPayload",
    value: function () {
      var _sendPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.wc = this.register(this.opts);
                _context4.prev = 1;
                _context4.next = 4;
                return this.wc.unsafeSend(payload);

              case 4:
                response = _context4.sent;
                return _context4.abrupt("return", this.sanitizeResponse(response));

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);
                return _context4.abrupt("return", this.onError(payload, _context4.t0.message));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 8]]);
      }));

      function sendPayload(_x3) {
        return _sendPayload.apply(this, arguments);
      }

      return sendPayload;
    }()
  }, {
    key: "sanitizeResponse",
    value: function sanitizeResponse(response) {
      return typeof response.error !== "undefined" && typeof response.error.code === "undefined" ? formatJsonRpcError(response.id, response.error.message) : response;
    }
  }]);

  return SignerConnection;
}(IJsonRpcConnection);
export default SignerConnection;